import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import toastr from "toastr";
import {
  saveOrderMission,
  isEmployeeOnMission,
} from "../../../../services/RHService/OrdreDeMissionService";
import "toastr/build/toastr.min.css";
import { useLocation } from "react-router-dom";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const AddMission = () => {
  const location = useLocation();
  const idPersonnel = new URLSearchParams(location.search).get("idUser");

  const [inputList, setInputList] = useState([{ nomCharge: "", frais: "" }]);

  const [formData, setFormData] = useState({
    intitule: "",
    villeDept: "",
    villeDest: "",
    paysDest: "",
    dateDeb: new Date(),
    dateFin: new Date(),
    heureDeb: "",
    heureFin: "",
    desc: "",
    charges: [],
  });

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];

    list[index][name] = value;
    setInputList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  const handleAddClick = () => {
    setInputList([...inputList, { nomCharge: "", frais: "" }]);
  };
  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      charges: inputList,
    }));
  }, [inputList]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmployeeonmission = await isEmployeeOnMission(idPersonnel);
    // console.log(isEmployeeonmission.data);
    // console.log(idPersonnel);
    // return;
    if (isEmployeeonmission.data >= 1) {
      toastr.error("Ce personnel est déja en mission");
      return;
    }
    if (
      !formData.dateDeb ||
      !formData.dateFin ||
      !formData.intitule ||
      !formData.villeDept ||
      !formData.villeDest ||
      !formData.paysDest ||
      !formData.heureDeb ||
      !formData.heureFin ||
      !formData.desc
    ) {
      toastr.error("Veuillez renseigner tous les champs.");
      return;
    }

    const invalidNomCharge = inputList.some((item) => item.nomCharge === "");
    if (invalidNomCharge) {
      toastr.error("N'oublier pas le nom de charge :)");
      return;
    }
    // Check if "frais" inputs are valid doubles
    const invalidFrais = inputList.some((item) => {
      const fraisRegex = /^\d+(\.\d{1,2})?$/;
      return !fraisRegex.test(item.frais);
    });

    if (invalidFrais) {
      toastr.error(
        "Les frais sont invalides : veuillez entrer que des chiffres."
      );
      return;
    }
    console.log(formData);
    if (
      formData.intitule &&
      formData.dateDeb &&
      formData.dateFin &&
      formData.villeDept &&
      formData.villeDest &&
      formData.paysDest &&
      formData.heureDeb &&
      formData.heureFin &&
      formData.desc &&
      !invalidFrais &&
      isEmployeeonmission.data === 0
    ) {
      try {
        const resp = await saveOrderMission(
          idPersonnel,
          getCurrentUserId(),
          formData
        );
        console.log(resp);
        toastr.success("Mission affecter avec succée");

        // if (data.status === 200) {
        //   toastr.success("Mission affecter avec succée");
        // }

        // Do something with the response data
      } catch (error) {
        console.log(error.message);
        // Show an error message or handle the error
      }
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              {/* <h1 className="m-0">Ajouter une mission</h1> */}
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                {/* <li className="breadcrumb-item"><i class="fa-solid fa-house"></i></li> */}
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/mission_order" style={{ color: "black" }}>
                    Liste des ordres de mission
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  Ajouter un ordre mission
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div className="col-md-12">
            <div className="card card-dark">
              <div class="card-header">
                <h4 class="card-title">Affecter un ordre de mission</h4>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="card-body">
                      <div className="form-group">
                        <label for="exampleInputPassword1">
                          Intitulé de mission
                        </label>
                        <input
                          type="text"
                          name="intitule"
                          className="form-control form-control-border"
                          value={formData.intitule}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              intitule: e.target.value,
                            })
                          }
                          placeholder="Intitulé de mission "
                        />{" "}
                      </div>
                      <div className="form-group">
                        <label for="exampleInputPassword1">
                          Ville de départ
                        </label>
                        <input
                          type="text"
                          name="villeDept"
                          value={formData.villeDept}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              villeDept: e.target.value,
                            })
                          }
                          className="form-control form-control-border"
                          placeholder="Ville de départ"
                        />{" "}
                      </div>
                      <div className="form-group">
                        <label for="exampleInputPassword1">
                          Ville de destination
                        </label>
                        <input
                          type="text"
                          name="villeDest"
                          value={formData.villeDest}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              villeDest: e.target.value,
                            })
                          }
                          className="form-control form-control-border"
                          placeholder="Ville de destination"
                        />{" "}
                      </div>
                      <div className="form-group">
                        <label for="exampleInputPassword1">
                          pays destination
                        </label>
                        <input
                          type="text"
                          name="paysDest"
                          value={formData.paysDest}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              paysDest: e.target.value,
                            })
                          }
                          className="form-control form-control-border"
                          placeholder="pays destination"
                        />{" "}
                      </div>
                      <div className="form-group">
                        <label>Date de départ</label>
                        <div
                          className="input-group date"
                          id="reservationdate"
                          data-target-input="nearest"
                        >
                          <input
                            type="date"
                            id="start"
                            value={formData.dateDeb}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                dateDeb: e.target.value,
                              })
                            }
                            name="dateDeb"
                            min="1900-01-01"
                            className="form-control form-control-border "
                          />{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card-body">
                      <div className="form-group">
                        <label>Date de fin</label>
                        <div
                          className="input-group date"
                          id="reservationdate"
                          data-target-input="nearest"
                        >
                          <input
                            type="date"
                            id="start"
                            name="dateFin"
                            value={formData.dateFin}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                dateFin: e.target.value,
                              })
                            }
                            min="1900-01-01"
                            className="form-control form-control-border "
                          />{" "}
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Heure Début</label>
                        <div
                          class="input-group date"
                          id="reservationdatetime"
                          data-target-input="nearest"
                        >
                          <input
                            className="form-control form-control-border"
                            value={formData.heureDeb}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                heureDeb: e.target.value,
                              })
                            }
                            type="time"
                            id="appt"
                            name="heureDeb"
                          />{" "}
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Heure fin</label>
                        <div
                          class="input-group date"
                          id="reservationdatetime"
                          data-target-input="nearest"
                        >
                          <input
                            className="form-control form-control-border"
                            type="time"
                            value={formData.heureFin}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                heureFin: e.target.value,
                              })
                            }
                            name="heureFin"
                          />{" "}
                        </div>
                      </div>
                      <div className="form-group">
                        <label for="exampleInputPassword1">Description</label>
                        <textarea
                          type="Textarea"
                          rows="2"
                          cols="33"
                          value={formData.desc}
                          onChange={(e) =>
                            setFormData({ ...formData, desc: e.target.value })
                          }
                          className="form-control form-control-border"
                          name="desc"
                          placeholder="Description"
                        ></textarea>
                      </div>
                      <label for="exampleInputPassword1">Charges :</label>
                      {inputList.map((x, i) => {
                        return (
                          <div className="box">
                            <input
                              name="nomCharge"
                              className="form-control form-control-border"
                              placeholder="Nom de charge"
                              onChange={(e) => handleInputChange(e, i)}
                            />
                            <input
                              name="frais"
                              className="form-control form-control-border ml10"
                              placeholder="Frais En Dt"
                              onChange={(e) => handleInputChange(e, i)}
                            />
                            <div className="btn-box">
                              {inputList.length !== 1 && (
                                <button
                                  className="mr10 mx-1 m-1"
                                  type="button"
                                  style={{
                                    "background-color": "black",
                                    color: "white",
                                    "border-radius": "50%",
                                    "border-color": "black",
                                  }}
                                  onClick={() => handleRemoveClick(i)}
                                >
                                  <i class="fa-solid fa-minus "></i>
                                </button>
                              )}
                              {inputList.length - 1 === i && (
                                <button
                                  onClick={handleAddClick}
                                  type="button"
                                  style={{
                                    "background-color": "black",
                                    color: "white",
                                    "border-radius": "50%",
                                    "border-color": "black",
                                  }}
                                >
                                  <i class="fa-solid fa-plus"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <button
                    type="submit"
                    className="btn btn-dark col-md-3 float-right"
                    style={{ width: "auto" }}
                  >
                    Confirmer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMission;
